import { Url } from '../../../../shared/constant/url.constant';

/**
 * Route utilisées pour les fees & benefits.
 */
export namespace ConstantTypeInputForm {
  export const data = {
    title: 'Type-input-form',
    sub: {
      lister: 'Lister',
      ajouter: 'Ajouter',
      ajout: {
        title: 'Ajout d\'un type input de formulaire'
      },
      liste: 'Liste',
      list: {
        title: 'Liste des types input de formulaire'
      }
    }

  }
  export const url = {
    FEES: {
      FEES_: 'type-input-form',
      LIST: 'liste',
      ADD: 'add'
    }
  };

  export const urlFull = {
    FEES: {
      ADD: ConstantTypeInputForm.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantTypeInputForm.url.FEES.ADD),
      LIST: ConstantTypeInputForm.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(ConstantTypeInputForm.url.FEES.LIST),
    }
  };
}
